/**
 * FooterPopup class
 */
class FooterPopup {
	/**
	 * This runs on load
	 */
	constructor() {
		this.footerPopupSec = document.querySelector('.gt-footer-popup-sec');
		this.popupBtn = document.querySelector('.gt-popup-btn-row .col');

		this.body = document.querySelector('body');
		this.overflowBreakPoint = 767;
		this.isPopupClosed = true;
	}

	/**
	 * Initialize class
	 *
	 * @return {void}
	 */
	init() {
		this.setUpOverlay();
		this.addEventListeners();
	}

	/**
	 * Add event listeners
	 *
	 * @return {void}
	 */
	addEventListeners() {
		this.popupBtn.addEventListener('click', this.toggleFooterPopup.bind(this));
		document.querySelector('.gt-popup-overlay').addEventListener('click', this.closePopup.bind(this));

		document.addEventListener('keydown', this.closePopupOnEsc.bind(this));
	}

	/**
	 * Setup overlay
	 *
	 * @return {void}
	 */
	setUpOverlay() {
		this.footerPopupSec.insertAdjacentHTML('afterbegin', '<div class="gt-popup-overlay" />');
	}

	/**
	 * Toggle popup
	 *
	 * @return {void}
	 */
	toggleFooterPopup() {
		if (this.isPopupClosed) {
			this.footerPopupSec.classList.add('popup-open');
		} else {
			this.footerPopupSec.classList.remove('popup-open');
		}

		this.isPopupClosed = !this.isPopupClosed;
		this.toggleOverflowBody();
	}

	/**
	 * Close popup
	 *
	 * @return {void}
	 */
	closePopup() {
		this.footerPopupSec.classList.remove('popup-open');
		this.isPopupClosed = !this.isPopupClosed;
		this.toggleOverflowBody();
	}

	/**
	 * Close popup on esc
	 *
	 * @param {Event} e
	 * @return {void}
	 */
	closePopupOnEsc(e) {
		const key = e.key;
		if (key === 'Escape') {
			this.footerPopupSec.classList.remove('popup-open');
			this.isPopupClosed = !this.isPopupClosed;
			this.toggleOverflowBody();
		}
	}

	/**
	 * Toggle overflow hidden when popup is open and window is less then this.overflowBreakPoint
	 *
	 * @return {void}
	 */
	toggleOverflowBody() {
		if (window.innerWidth < this.overflowBreakPoint && this.isPopupClosed === false) {
			this.body.style.overflow = 'hidden';
		} else if (this.isPopupClosed === true) {
			this.body.style.overflow = '';
		}
	}
}

// Check if module exist before class runs
if (document.querySelector('.gt-footer-popup-sec')) {
	document.addEventListener('DOMContentLoaded', () => {
		const footerPopup = new FooterPopup();
		footerPopup.init();
	});
}
